// extracted by mini-css-extract-plugin
export var avatarContainer = "_8z-0";
export var avatarTypingWave = "_8z-i";
export var gray = "_8z-f";
export var green = "_8z-c";
export var icon = "_8z-9";
export var image = "_8z-1";
export var lg = "_8z-6";
export var md = "_8z-5";
export var presenceDot = "_8z-b";
export var red = "_8z-d";
export var sm = "_8z-4";
export var status = "_8z-a";
export var typingDot = "_8z-h";
export var typingPill = "_8z-g";
export var xl = "_8z-7";
export var xs = "_8z-3";
export var xxl = "_8z-8";
export var xxs = "_8z-2";
export var yellow = "_8z-e";